import classNames from 'classnames';

export const cn = classNames;

export type ClassNameArgument = classNames.Argument;

export type ClassNameArgumentArray = classNames.ArgumentArray;
